import { useEffect, useRef, useState } from "react";
import { getBillingNumberPreview } from "utils/billingNumberPreview";
import { showResMsg } from "utils/generic";

export default function useBillingDocumentNumber({
  type,
  documentID,
  businessUserID,
  setValues,
}) {
  const [loading, setLoading] = useState(!documentID);
  const editedRef = useRef(false);
  const field = `${type}Number`;

  useEffect(() => {
    if (documentID || !businessUserID) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    setLoading(true);
    getBillingNumberPreview(type, businessUserID)
      .then((number) => {
        if (!active) return;
        setValues((previous) =>
          previous[`${type}ID`] || editedRef.current
            ? previous
            : {
                ...previous,
                [field]: number,
                [`${field}Edited`]: false,
              }
        );
      })
      .catch((error) => {
        if (active) {
          const label = type === "invoice" ? "invoice" : "RCTI";
          const message =
            error.response?.status === 404
              ? `Could not load the next ${label} number. You can enter a number manually.`
              : error.response?.data?.Result_Message ||
                `Could not load the next ${label} number. Please try again.`;
          showResMsg(message, 2500, false);
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [type, documentID, businessUserID, field, setValues]);

  const onChange = (event) => {
    editedRef.current = true;
    const value = event.target.value;
    setValues((previous) => ({
      ...previous,
      [field]: value,
      [`${field}Edited`]: true,
    }));
  };

  return { loading, onChange };
}
